import React, { useState, useEffect, useContext } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import { InputAdornment, Switch } from '@mui/material';
import { ModalPPVPriceContext } from '../ModalPPVPrice/context';
import './style.scss';

const TimedPricing = ({ }) => {
    const [priceHelpText, setPriceHelpText] = useState('');
    const [promoPriceHelpText, setPromoPriceHelpText] = useState('');
    const [priceError, setPriceError] = useState(false);
    const [promoPriceError, setPromoPriceError] = useState(false);

    const {
        welcomePrice,
        setWelcomePrice,
        promoPrice,
        setPromoPrice,
        isDiscounted,
        setIsDiscounted,
        minPpvPrice,
        maxPpvPrice,
        expiry,
        setExpiry,
        // dispatchAlert,
    } = useContext(ModalPPVPriceContext);

    const handlePriceChange = e => {
        const value = e.target.value;
        const formattedPrice = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        }).replace(/[^.\d]/g, '');

        setWelcomePrice(formattedPrice);
    };

    const handlePromoPriceChange = e => {
        const value = e.target.value;
        const formattedPrice = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        }).replace(/[^.\d]/g, '');

        if (parseFloat(formattedPrice) >= parseFloat(welcomePrice)) {
            return;
        }

        setPromoPrice(formattedPrice);
    };

    const handleIsDiscounted = () => {
        setIsDiscounted(isDiscounted => !isDiscounted);
    };

    useEffect(() => {
        setPriceHelpText(`Min $${minPpvPrice} USD`);
    }, []);

    useEffect(() => {
        if (isDiscounted) {
            setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
        }
    }, [isDiscounted]);

    useEffect(() => {
        if (maxPpvPrice && parseFloat(welcomePrice) > parseFloat(maxPpvPrice)) {
            setPriceHelpText(`Max $${parseFloat(maxPpvPrice)} USD`);
            setPriceError(true);
        }

        if (maxPpvPrice && parseFloat(welcomePrice) < parseFloat(minPpvPrice)) {
            setPriceHelpText(`Min $${parseFloat(minPpvPrice)} USD`);
            setPriceError(true);
        }

        if ((parseFloat(welcomePrice) >= parseFloat(minPpvPrice) && parseFloat(welcomePrice) <= parseFloat(maxPpvPrice)) || welcomePrice?.length === 0) {
            setPriceHelpText('');
            setPriceError(false);
        }

        if (parseFloat(promoPrice) > parseFloat(welcomePrice)) {
            setPromoPriceHelpText(`Max $${parseFloat(welcomePrice) - .1} USD`);
            setPromoPriceError(true);
        }
        if (parseFloat(promoPrice) < parseFloat(minPpvPrice)) {
            setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
            setPromoPriceError(true);
        }

        if ((parseFloat(promoPrice) >= parseFloat(minPpvPrice) && parseFloat(promoPrice) < parseFloat(welcomePrice)) || promoPrice?.length === 0) {
            setPromoPriceHelpText('');
            setPromoPriceError(false);
        }
    }, [promoPrice, welcomePrice, minPpvPrice, maxPpvPrice]);

    useEffect(() => {
        setPriceHelpText(`Min $${parseFloat(minPpvPrice)} USD`);
        setPromoPriceHelpText(`Min $${minPpvPrice} USD`);
    }, [minPpvPrice]);

    const onHandleExpiryChange = (e) => {
        let value = e.target.value;

        if(value == '' || value == null || value == 0) {
            value = 0;
        } else if(value > 99) {
            return;
        } else {
            if(isNaN(Number(value))) {
                return;
            }

            value = Number(value).toString().replace(/^0+/, '');
        }

        setExpiry({
            ...expiry,
            [e.target.name]: value
        });
    }

    return <div
        className='welcome-message-price'
    >
        <div className='welcome-message-price-title'>
            <div style={{ marginTop: '10px' }}>
                <TextField
                    type='text'
                    id="welcomeMessagePrice"
                    label="Price"
                    variant="outlined"
                    value={welcomePrice}
                    onChange={handlePriceChange}
                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                    size='small'
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    helperText={priceHelpText}
                    error={priceError}
                    style={{ width: '100%' }}
                />
            </div>
            <div style={{ marginTop: '10px' }}>
                <FormControlLabel
                    control={<Switch
                        checked={isDiscounted}
                        onChange={handleIsDiscounted}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                    label="Limited discount offer"
                />
            </div>
            {
                isDiscounted && <div style={{ marginTop: '10px' }}>
                    <TextField
                        type='text'
                        id="welcomeMessagePromoPrice"
                        label="Discounted Price"
                        variant="outlined"
                        value={promoPrice}
                        onChange={handlePromoPriceChange}
                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                        size='small'
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        helperText={promoPriceHelpText}
                        error={promoPriceError}
                        style={{ width: '100%' }}
                    />
                </div>
            }
            {
                isDiscounted && 
                <>
                    <div className="limited-offer-ppv-date-picker">
                        <div className="price-modal-expiry-fields">
                            <div className="expiry-field">
                                <span>Days</span>
                                <TextField
                                    hiddenLabel
                                    name="days"
                                    variant="filled"
                                    inputProps={{min: 0, style: { textAlign: 'center' }}}
                                    value={expiry.days}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>

                            <div className="expiry-field">
                                <span>Hrs</span>
                                <TextField
                                    hiddenLabel
                                    name="hours"
                                    variant="filled"
                                    inputProps={{min: 0, style: { textAlign: 'center' }}}
                                    value={expiry.hours}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>

                            <div className="expiry-field">
                                <span>Mins</span>
                                <TextField
                                    hiddenLabel
                                    name="minutes"
                                    variant="filled"
                                    inputProps={{min: 0, style: { textAlign: 'center' }}}
                                    value={expiry.minutes}
                                    onChange={onHandleExpiryChange}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    </div>;
};

export default TimedPricing;